// @ts-nocheck
import { DashboardLayout } from "./Dashboard";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Plus, Search, UserCheck, Mail, Phone, Edit, Eye, X } from "lucide-react";
import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { toast } from "sonner";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useAuth } from "@/contexts/use-auth";
import { useOrg } from "@/contexts/useOrg";
import { useGetData } from "@/hooks/useGetData";
import LoaderWrapper from "./LoaderWrapper";
import { HorizontalCardShimmer } from "@/components/Shimmer";
import { useDebouncedInput } from "@/hooks/useDebouncedInput";
import { PhoneInput } from "@/components/ui/input-phone";
import { AxiosHeaders } from "axios";
import AxiosInstance from "@/utils/AxiosInstance";
import RHFWrapper from "@/components/RHFWrapper";
import CommonFormFields from "@/components/CommonFormFields";
import RhfInput from "@/components/rhfFields/RhfInput";
import Grid from "@/components/Grid";
import RhfSelect from "@/components/rhfFields/RhfSelect";
import MyDialogContent from "@/components/MyDialogContent";
import * as yup from "yup";
import {
  CommonFieldSchema,
  PractitionerSchema,
} from "@/utils/ValidataionSchemas";
import RhfMultiInput from "@/components/rhfFields/RhfMultiInput";
import NpiSearch from "@/components/NpiSearch";
import TableWithSearch from "@/components/TableWithSearch";
import { practitionersTableHeaders } from "@/utils/tablesData";
import {
  getNpiDataForProviders,
  getPromise,
  getPromiseToast,
} from "@/utils/helpers";
import {
  capitalizeTheStartingCharacterFilter,
  PERSON_CAPITALIZE_FIELDS,
} from "@/constants/payloadFilters";
import { useNavigate } from "react-router";

export default function Practitioners({isDialogOpen, setIsDialogOpen, isView, providers, setProviders} :any) {
  const [search, setSearch] = useState("");
  // const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedPractitioner, setSelectedPractitioner] =
    useState<Practitioner | null>(null);
  const [isViewDialogOpen, setIsViewDialogOpen] = useState(false);
  const [selectedOrgForAdd, setSelectedOrgForAdd] =
    useState<Id<"organizations"> | null>(null);
  const [selectedFacilityForAdd, setSelectedFacilityForAdd] =
    useState<Id<"facilities"> | null>(null);

  // TODO: Replace with actual API calls
  // const [organizations] = useState<Organization[]>(mockOrganizations);
  const { user } = useAuth();

  return (
    // <DashboardLayout activePage="/practitioners">
      <PractitionersContent
        // search={search}
        // setSearch={setSearch}
        isDialogOpen={isDialogOpen}
        setIsDialogOpen={setIsDialogOpen}
        selectedPractitioner={selectedPractitioner}
        setSelectedPractitioner={setSelectedPractitioner}
        isViewDialogOpen={isViewDialogOpen}
        setIsViewDialogOpen={setIsViewDialogOpen}
        selectedOrgForAdd={selectedOrgForAdd}
        setSelectedOrgForAdd={setSelectedOrgForAdd}
        selectedFacilityForAdd={selectedFacilityForAdd}
        setSelectedFacilityForAdd={setSelectedFacilityForAdd}
        user={user}
        isView={isView}
         providers={ providers} setProviders={setProviders}
      />
    // </DashboardLayout>
  );
}

function PractitionersContent({
  // search,
  // setSearch,
  isDialogOpen,
  setIsDialogOpen,

  selectedPractitioner,
  setSelectedPractitioner,
  isViewDialogOpen,
  setIsViewDialogOpen,
  selectedOrgForAdd,
  setSelectedOrgForAdd,
  selectedFacilityForAdd,
  setSelectedFacilityForAdd,
  user,
  isView,
  providers,
  setProviders
}: {
  // search: string;
  // setSearch: (value: string) => void;
  isDialogOpen: boolean;
  setIsDialogOpen: (value: boolean) => void;

  selectedPractitioner: Practitioner | null;
  setSelectedPractitioner: (value: Practitioner | null) => void;
  isViewDialogOpen: boolean;
  setIsViewDialogOpen: (value: boolean) => void;
  selectedOrgForAdd: string | null;
  setSelectedOrgForAdd: (value: string | null) => void;
  selectedFacilityForAdd: Id<"facilities"> | null;
  setSelectedFacilityForAdd: (value: Id<"facilities"> | null) => void;
  user: any;
  isView:any;
  providers:any;
  setProviders:any
}) {
  const { isAuthorized } = useAuth();

  const { organizations, selectedOrgId, isAllSelected } = useOrg();
  const [btnLoading, setBtnLoading] = useState(false);

  // TODO: Replace with actual API calls
  const facilities =
    organizations.find((o) => o._id == selectedOrgForAdd)?.facilities || [];
  //   useQuery(
  //   api.organizations.getFacilities,
  //   selectedOrgForAdd ? { organizationId: selectedOrgForAdd } : "skip"
  // );
  const [practitioners, setPractitioners] = useState<Practitioner[]>([]);
  // const [allPractitioners, // setAllPractitioners] = useState<Practitioner[]>([]);
  // const [providers, setProviders] = useState<Provider[]>([]);
  const hasProvidersAvailable =
    providers && Array.isArray(providers) && providers.length > 0;
  const [allProvidersForButtonCheck, setAllProvidersForButtonCheck] = useState<
    Provider[]
  >([]);
  const {
    input: inputSearch,
    setInput: setInputSearch,
    debouncedInput: search,
  } = useDebouncedInput("", 500);
  const nav= useNavigate();

  // const [inputSearch ,setInputSearch ] =useState(search);

  // const { apiData, loading, err, fetchData : reFetchPrac } = useGetData(
  //   "/practitioners",
  //   { orgId: selectedOrgId, search },
  //   false,
  //   !!selectedOrgId,
  //   (err, data) => {
  //     if (data && !err) {
  //       setPractitioners(data?.data?.practitioners);
  //       // setAllPractitioners
  //     }
  //   },
  // );
  const { loading: providerLoading } = useGetData(
    "/providers",
    { orgId: selectedOrgId },
    false,
    !!isView && !!selectedOrgId && !hasProvidersAvailable,
    (err, data) => {
      if (data && !err) {
        setProviders(data?.data?.providers);
      }
    },
  );

  useEffect(() => {
    // TODO: Call API to fetch all practitioners (for Anthro Care)
    // Example: fetchAllPractitioners().then(// setAllPractitioners)
    if (isAllSelected) {
      // setAllPractitioners(mockPractitioners);
    }
  }, [isAllSelected]);

  // Determine which organization to use for filtering providers
  const orgIdForFiltering = isAllSelected ? selectedOrgForAdd : selectedOrgId;

  // Determine if we should disable the Add button

  const selectedOrganization = organizations?.find(
    (org) => org._id === selectedOrgId,
  );

  const handleCreatePractitioner = async (formData, methods) => {
    const { pr, rejectFn, resolveFn } = getPromise();
    getPromiseToast(pr);
    // e.preventDefault();
    try {
      setBtnLoading(true);

      const newPractitioner = {
        firstName: formData?.firstName,
        middleName: formData?.middleName,
        lastName: formData?.lastName,
        dateOfBirth: formData?.dateOfBirth,
        email: formData?.email,
        phone: formData?.phone,
        street: formData?.street,
        city: formData?.city,
        state: formData?.state,
        zipcode: formData?.zipcode,
        gender: formData?.gender,
        status: formData?.status,
        timezone: formData?.timezone,
        organizationId: formData?.organizationId,
        providerId: formData?.providerId,
        npiNumber: formData?.npiNumber,
        specializations: formData?.specializations,
        taxonomies: formData?.taxonomies,
      };
      console.log("CREATE PRATIONER", newPractitioner);

      const { data } = await AxiosInstance().post(
        "/practitioners",
        capitalizeTheStartingCharacterFilter(
          newPractitioner,
          PERSON_CAPITALIZE_FIELDS,
        ),
      );

      setPractitioners((p) => [
        data?.data ? data?.data : newPractitioner,
        ...p,
      ]);

      resolveFn("Practitioner added successfully");
      setIsDialogOpen(false);
      setSelectedOrgForAdd(null);
      setSelectedFacilityForAdd(null);
    } catch (error) {
      rejectFn(error);
            if(methods){
if(error?.response?.data?.message.includes("email") && error?.response?.data?.message.includes("exist") )
     methods.setError('email', {message: 'Email Already Exists'})

if(error?.response?.data?.message.includes("phone") && error?.response?.data?.message.includes("exist") )
     methods.setError('phone', {message: 'Phone Number Already Exists'})
      }
    } finally {
      setBtnLoading(false);
    }
  };

  const handleUpdatePractitioner = async (formData, methods) => {
    if (!selectedPractitioner) return;
    const { pr, rejectFn, resolveFn } = getPromise();
    getPromiseToast(pr);
    try {
      setBtnLoading(true);

      const updatedPractitioner = {
        firstName: formData?.firstName,
        middleName: formData?.middleName,
        lastName: formData?.lastName,
        dateOfBirth: formData?.dateOfBirth,
        email: formData?.email,
        phone: formData?.phone,
        street: formData?.street,
        city: formData?.city,
        state: formData?.state,
        zipcode: formData?.zipcode,
        gender: formData?.gender,
        status: formData?.status,
        timezone: formData?.timezone,
        organizationId: formData?.organizationId,
        providerId: formData?.providerId,
        npiNumber: formData?.npiNumber,
        specializations: formData?.specializations,
        taxonomies: formData?.taxonomies,
      };
      console.log("UPDATE PARTITIONER", updatedPractitioner);

      const { data } = await AxiosInstance().put(
        "/practitioners/" + selectedPractitioner?._id,
        capitalizeTheStartingCharacterFilter(
          updatedPractitioner,
          PERSON_CAPITALIZE_FIELDS,
        ),
      );

      // if (isAllSelected) {
      // // setAllPractitioners((prev) =>
      //   prev.map((p) =>
      //     p._id === selectedPractitioner._id ? updatedPractitioner : p,
      //   ),
      // );
      // } else {
      setPractitioners((prev) =>
        prev.map((p) => (p._id === selectedPractitioner._id ? data?.data : p)),
      );
      // }

      resolveFn("Practitioner updated successfully");
      setIsViewDialogOpen(false);
      setSelectedPractitioner(null);
    } catch (error) {
      rejectFn(error);
            if(methods){
if(error?.response?.data?.message.includes("email") && error?.response?.data?.message.includes("exist") )
     methods.setError('email', {message: 'Email Already Exists'})

if(error?.response?.data?.message.includes("phone") && error?.response?.data?.message.includes("exist") )
     methods.setError('phone', {message: 'Phone Number Already Exists'})
      }
    } finally {
      setBtnLoading(false);
    }
  };

  const handleViewPractitioner = (practitioner: any) => {
    console.log(practitioner);
    setSelectedPractitioner(practitioner);
    setIsViewDialogOpen(true);
  };

  const handleDialogOpenChange = (open: boolean) => {
    setIsDialogOpen(open);
    if (open) {
      setSelectedOrgForAdd(selectedOrgId);
    } else {
      setSelectedOrgForAdd(null);
      setSelectedFacilityForAdd(null);
    }
  };

  const filteredPractitioners = practitioners;
  return (
    // <DashboardLayout activePage="/practitioners" rightcomponent={<>
    //     {isAuthorized("canAddPractitioners") && (
    //       <Dialog open={isDialogOpen} onOpenChange={handleDialogOpenChange}>
    //         <DialogTrigger asChild>
    //           <Button
    //             className="w-full sm:w-auto"
    //             disabled={!hasProvidersAvailable}
    //             title={!hasProvidersAvailable ? "No providers available" : ""}
    //           >
    //             {hasProvidersAvailable && <Plus className="w-4 h-4 mr-2" />}
    //             {providerLoading
    //               ? "Loading ..."
    //               : hasProvidersAvailable
    //                 ? "Add Practitioner"
    //                 : "No Provider"}
    //           </Button>
    //         </DialogTrigger>

    //         <MyDialogContent heading="Add New Practitioner">
    //           <PractitionerForm
    //             key={`new${isDialogOpen}`}
    //           // key={}
    //             btnloading={btnLoading}
    //             className={"space-y-6"}
    //             facilities={facilities}
    //             isEdit={false}
    //             defaultValues={{}}
    //             onClose={() => handleDialogOpenChange(false)}
    //             organizations={organizations}
    //             providers={providers}
    //             onSubmit={handleCreatePractitioner}
    //           />
    //         </MyDialogContent>
    //       </Dialog>
    //     )}

    // </>}>
    <div className="">

       

    
        <Dialog open={isViewDialogOpen} onOpenChange={setIsViewDialogOpen}>
          <MyDialogContent heading="Practitioner Details">
            {selectedPractitioner && (
              <PractitionerForm
              key={`${selectedPractitioner?._id}`}
                btnloading={btnLoading}
                className={"space-y-6"}
                facilities={facilities}
                isEdit={true}
                defaultValues={selectedPractitioner}
                onClose={() => {
                  setIsViewDialogOpen(false);
                  setSelectedPractitioner(null);
                }}
                organizations={organizations}
                providers={providers}
                onSubmit={handleUpdatePractitioner}
              />
            )}
          </MyDialogContent>
        </Dialog>
            {isAuthorized("canAddPractitioners") && (
          <Dialog open={isDialogOpen} onOpenChange={handleDialogOpenChange}>
            {/* <DialogTrigger asChild>
              <Button
                className="w-full sm:w-auto"
                disabled={!hasProvidersAvailable}
                title={!hasProvidersAvailable ? "No providers available" : ""}
              >
                {hasProvidersAvailable && <Plus className="w-4 h-4 mr-2" />}
                {providerLoading
                  ? "Loading ..."
                  : hasProvidersAvailable
                    ? "Add Practitioner"
                    : "No Provider"}
              </Button>
            </DialogTrigger> */}

            <MyDialogContent heading="Add New Practitioner">
              <PractitionerForm

                key={`new${isDialogOpen}`}
                btnloading={btnLoading}
                className={"space-y-6"}
                facilities={facilities}
                isEdit={false}
                defaultValues={
                  selectedOrgId ? { organizationId: selectedOrgId } : {}
                }
                onClose={() => handleDialogOpenChange(false)}
                organizations={organizations}
                providers={providers}
                onSubmit={handleCreatePractitioner}
              />
            </MyDialogContent>
          </Dialog>
        )}
    

      {/* <Card>
        <CardHeader>
          <div className="flex flex-col md:flex-row gap-4 items-start md:items-center justify-between">
            <CardTitle>Practitioner List</CardTitle>
            <div className="relative flex-1 md:w-64">
              <Search className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
              <Input
                placeholder="Search practitioners..."
                value={inputSearch}
                onChange={(e) => setInputSearch(e.target.value)}
                className="pl-9 pr-9"
              />
              {inputSearch && (
                <button
                  type="button"
                  onClick={() => setInputSearch("")}
                  className="absolute right-3 top-3 h-4 w-4 text-muted-foreground hover:text-foreground transition-colors"
                  aria-label="Clear search"
                >
                  <X className="h-4 w-4" />
                </button>
              )}
            </div>
          </div>
        </CardHeader>
        <CardContent>
          <LoaderWrapper
            loading={loading}
            error={false}
            customLoaderComponent={<HorizontalCardShimmer count={4} />}
          >
            {filteredPractitioners && filteredPractitioners.length > 0 ? (
              <div className="space-y-4">
                {filteredPractitioners.map((practitioner, index) => (
                  <motion.div
                    key={practitioner._id}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.05 }}
                    className="p-6 border rounded-lg hover:shadow-md transition-all"
                  >
                    <div className="flex flex-col gap-3">
                      <div className="flex items-start justify-between">
                        <div className="space-y-3 flex-1">
                          <div>
                            <h3 className="text-lg font-semibold">
                              {practitioner.firstName} {practitioner.lastName}
                            </h3>
                            {practitioner.specialty && (
                              <p className="text-sm text-muted-foreground mt-1">
                                {practitioner.specialty}
                              </p>
                            )}
                          </div>

                          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm text-muted-foreground">
                            <div className="flex items-center gap-2">
                              <Mail className="w-4 h-4" />
                              <span>{practitioner.email}</span>
                            </div>
                            <div className="flex items-center gap-2">
                              <Phone className="w-4 h-4" />
                              <span>{practitioner.phone}</span>
                            </div>
                          </div>
                        </div>

                        <span
                          className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${
                            practitioner.status === "active"
                              ? "bg-green-100 text-green-800"
                              : "bg-gray-100 text-gray-800"
                          }`}
                        >
                          {practitioner.status}
                        </span>
                      </div>

                      {isAuthorized("canAddPractitioners") && (
                        <div className="flex justify-end">
                          <Button
                            variant="outline"
                            size="sm"
                            onClick={() => handleViewPractitioner(practitioner)}
                          >
                            <Edit className="w-4 h-4 mr-2" />
                            View Details
                          </Button>
                        </div>
                      )}
                    </div>
                  </motion.div>
                ))}
              </div>
            ) : (
              <div className="text-center py-12">
                <UserCheck className="w-12 h-12 text-muted-foreground mx-auto mb-4" />
                <p className="text-muted-foreground">
                  {search
                    ? "No practitioners found matching your criteria"
                    : "No practitioners yet. Add your first practitioner to get started."}
                </p>
              </div>
            )}
          </LoaderWrapper>
        </CardContent>
      </Card> */}
   {!!isView &&   <TableWithSearch
        fetchCondition={!!selectedOrgId}
        heading="Practitioners List"
        isIncludeSearch
        clickRow={() => {}}
        columnPreferenceKey="practitioners-list"
        apiDataKey="practitioners"
        columnHeaders={practitionersTableHeaders}
        searchPlaceholder="Search practitioners"
        url="/practitioners"
        params={{ orgId: selectedOrgId }}
        viewData={(practitioners || []).map(v=> {
          const pro = providers.find(org=> org?._id == v?.providerId)
          return{
          ...v,
          firstName: `${v?.firstName || ""} ${v?.middleName || ""} ${v?.lastName || ""}`,
          address: [v?.street, v?.city, v?.state, v?.zipcode]
            .map((part) => String(part ?? "").trim())
            .filter(Boolean)
            .join(", "),
          providerId : `${pro?.firstName || ""} ${pro?.middleName || ""} ${pro?.lastName || ""}`
        }
        })}
        data={practitioners}
        setData={setPractitioners}
        isActionColumn
        handleAction={(data) => handleViewPractitioner(data)}
        // clickRow={(data:any)=> nav(data?._id,{state: {data}})}
        isColumnSelection
        moreActions={[
          {
            label : "View ",
            icon: <Eye/>,
            isShow : ()=> true,
            onClick : (data)=> nav(data?._id,{state: {data}})
          }
        ]}

      />}
    </div>
// {/* </DashboardLayout> */}

  );
}

export const PractitionerForm = ({
  isEdit,
  btnloading,
  defaultValues,
  organizations,
  onSubmit,
  onClose,
  className,
  facilities,
  providers,
} :any) => {
  const [npidefaultValues, setNpiDefaultValues] = useState({
    ...defaultValues,
    organizationId: defaultValues?.organizationId === 'anthro-care' ? null : defaultValues?.organizationId,
  });
  console.log({ defaultValues, npidefaultValues });
  return (
    <RHFWrapper
      isValidate={true}
      initialValues={npidefaultValues}
      validateSchema={yup.object({
        ...CommonFieldSchema,
        ...PractitionerSchema,
      })}
      className={className}
      onSubmit={onSubmit}
    >
      {/* <NpiSearch
        getValues={(values) => {
          const prefildata = getNpiDataForProviders(
            values?.data?.details?.results?.[0],
          );
          setNpiDefaultValues((p) => ({ ...p, ...prefildata }));
        }}
      /> */}
      <CommonFormFields defaultValues={npidefaultValues} isEdit={true} />

      {Array.isArray(organizations) && organizations.length > 0 && (
        <Grid count={{ sm: 1, md: 2 }}>
          <RhfSelect
            label="Organization"
            required={true}
            name="organizationId"
            defaultvalue={npidefaultValues?.organizationId ?? ""}
            disabled={Array.isArray(organizations) && organizations.length === 1}
            options={
              Array.isArray(organizations)
                ? organizations.map((org) => ({
                    label: org.organizationName,
                    value: org?._id,
                  }))
                : []
            }
            placeholder={
              !organizations || organizations?.length === 0
                ? "No organizations available"
                : null
            }
          />
        </Grid>
      )}
      <Grid count={{ sm: 1, md: 2 }}>
        <FaciltyAndProvider facilities={facilities} providers={providers} />
        <RhfInput
          name="npiNumber"
          label="NPI Number"
          required
          isNumber
          defaultvalue={defaultValues?.npiNumber ?? ""}
          maxLength={10}
        />
      </Grid>

      <div>
        <RhfMultiInput
          name="specializations"
          label="Specializations"
          required={true}
        />
      </div>
      <div>
        <RhfMultiInput name="taxonomies" label="Taxonomies" required={true} />
      </div>

      <div className="flex justify-end gap-3 pt-2 sticky bottom-0 w-full bg-white">
        <Button type="button" variant="outline" onClick={onClose}>
          Cancel
        </Button>
        <Button disabled={btnloading} type="submit">
          <Edit className="w-4 h-4 mr-2" />
          {!isEdit ? "Add" : "Update"} Practitioner
        </Button>
      </div>
    </RHFWrapper>
  );
};

const FaciltyAndProvider = ({ facilities, providers }) => {
  return (
    <>
      <RhfSelect
        name="providerId"
        required
        options={
          Array.isArray(providers)
            ? providers.map((org) => ({
                label: org?.firstName
                  ? `${org?.firstName} ${org?.lastName}`
                  : org?.name,
                value: org?._id,
              }))
            : []
        }
        placeholder={
          !providers || providers?.length == 0 ? "No provider available" : null
        }
        label="Provider"
      />
    </>
  );
};
